<template>
    <div v-if="details">
        <b-tabs pills card vertical>
            <b-tab title="Ceza Bilgileri" active>
                
                    <h5>Temel Ceza Bilgileri</h5>
                    <table class="table table-sm table-striped table-bordered mb-2">
                        <tbody>
                            <tr>
                                <td class="w-60 bg-lightest-muted">Durum</td>
                                <td>
                                    <b-badge :variant="statusVariant">{{ details.StatusName || "-" }}</b-badge>
                                </td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Tutanak - Seri / Sıra No</td>
                                <td>{{ details.ReportNumber || "-" }}</td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Ceza Maddesi</td>
                                <td>{{ details.TrafficFine ? details.TrafficFine.Clause : "-" }}</td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Ceza Açıklaması</td>
                                <td style="white-space: normal">{{ details.TrafficFine ? details.TrafficFine.Description : "-" }}</td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Ceza Tarihi</td>
                                <td>{{ details.FineDate }}</td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Tebliğ Kaynağı</td>
                                <td>{{ details.NotifyOriginName }}</td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Tebliğ Tarihi</td>
                                <td>{{ details.NotifyDate }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <h5>Finansal Bilgiler</h5>
                    <table class="table table-sm table-striped table-bordered mb-2">
                        <tbody>
                            <tr>
                                <td class="w-60 bg-lightest-muted">Ceza Tutarı (TL)</td>
                                <td>{{ details.FineAmount | currency }}</td>
                            </tr>
                            <!-- <tr>
                                <th>İndirimli Tutar (TL)</th>
                                <td class="font-weight-bold">{{ details.DiscountedFineAmountStr || "0,00" }}</td>
                            </tr> -->
                            <tr>
                                <td class="bg-lightest-muted">Planlanan Personel Payı (TL)</td>
                                <td>{{ details.DriverAmountStr || "0,00" }}</td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Planlanan Firma Payı (TL)</td>
                                <td>{{ details.CompanyAmountStr || "0,00" }}</td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Gerçekleşen Personel Payı (TL)</td>
                                <td>{{ details.ActualDriverAmountStr || "-" }}</td>
                            </tr>
                            <tr>
                                <td class="bg-lightest-muted">Gerçekleşen Firma Payı (TL)</td>
                                <td>{{ details.ActualCompanyAmountStr || "-" }}</td>
                            </tr>
                        </tbody>
                    </table>
            </b-tab>

            <b-tab title="Personel ve Araç">
                <b-card-text>
                    <h5>Personel Bilgileri</h5>
                    <table class="table table-sm table-striped table-bordered mb-2">
                        <tbody>
                            <tr>
                                <th class="w-60">Personel</th>
                                <td>{{ details.Employee ? details.Employee.FullName : "-" }}</td>
                            </tr>
                            <tr>
                                <th>Sicil No</th>
                                <td>{{ details.Employee ? details.Employee.RegistrationCode : "-" }}</td>
                            </tr>
                            <tr>
                                <th>T.C. Kimlik No</th>
                                <td>{{ details.Employee ? details.Employee.IdentityNumber : "-" }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <h5>Araç Bilgileri</h5>
                    <table class="table table-sm table-striped table-bordered mb-2">
                        <tbody>
                            <tr>
                                <th class="w-60">Plaka</th>
                                <td>{{ details.Plate ? details.Plate.PlateValue : "-" }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <h5>Sürücü Ceza Puanı</h5>
                    <table class="table table-sm table-striped table-bordered mb-0">
                        <tbody>
                            <tr>
                                <th class="w-60">İlgili Ceza Puanı</th>
                                <td>
                                    <b-badge variant="light-dark">{{ details.TrafficFine ? details.TrafficFine.Point : 0 }} Puan</b-badge>
                                </td>
                            </tr>
                            <tr>
                                <th>Resmi Ceza Puanı</th>
                                <td class="font-weight-bold">
                                    <b-badge variant="light-dark">{{ details.PointsLast1Year || 0 }} Puan</b-badge>
                                    <small v-if="details.PointsLast1Year >= 80" class="text-danger ml-1">(Eşiğe Ulaştı)</small>
                                </td>
                            </tr>
                            <tr>
                                <th class="w-40">Kalan Resmi Ceza Puanı</th>
                                <td class="font-weight-bold">
                                    <b-badge :variant="100 - (details.PointsLast1Year || 0) < 20 ? 'light-danger' : 'light-success'"> {{ 100 - (details.PointsLast1Year || 0) }} Puan </b-badge>
                                    <small v-if="100 - (details.PointsLast1Year || 0) < 20" class="text-danger ml-1">(Kritik Seviye)</small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card-text>
            </b-tab>

            <b-tab title="Açıklama ve Dosya">
                <b-card-text>
                    <h5>Açıklama</h5>
                    <p class="card-text">{{ details.Description || "Açıklama bulunmamaktadır." }}</p>
                    <h5 class="mt-2">Ekli Dosya</h5>
                    <div v-if="details.Document">
                        <ul class="list-group">
                            <li class="list-group-item">
                                <a :href="details.Document" target="_blank" class="d-flex align-items-center">
                                    <feather-icon icon="FileTextIcon" class="mr-50" /> {{ getFileName(details.Document) }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <p>Dosya eki bulunmamaktadır.</p>
                    </div>
                </b-card-text>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { BAlert, BTabs, BTab, BCardText, BBadge, BRow, BCol,BCard } from "bootstrap-vue";

export default {
    components: {
        BAlert,
        BTabs,
        BTab,
        BCardText,
        BBadge,
        BRow,
        BCol,
        BCard
    },
    props: {
        details: { type: Object, default: null },
    },
    computed: {
        statusVariant() {
            if (!this.details) return "secondary";
            switch (this.details.Status) {
                case 0:
                case 4:
                    return "light-warning";
                case 1:
                    return "light-success";
                case 2:
                    return "light-secondary";
                case 3:
                    return "light-info";
                default:
                    return "light-primary";
            }
        },
    },
    methods: {
        getFileName(url) {
            if (!url) return "Bilinmeyen Dosya";
            return url.substring(url.lastIndexOf("/") + 1);
        },
    },
    filters: {
        currency(value) {
            if (typeof value !== "number") return "0,00";
            return value.toLocaleString("tr-TR", { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
    },
};
</script>

<style scoped>

.bg-lightest-muted {
    background-color: #f9f9f9 !important;
    border-color: #eaeaea;
    border-style: solid;
    border-width: 1px;
}

.dark-layout .bg-lightest-muted {
    background-color: #3b425365 !important;
    border-color: #434b56;
}
</style>
